<template>
  <v-row class="pl-6 ma-0 condition-wrap">
    <v-col
      cols="12"
      class="pa-0 d-flex justify-space-between"
      @click="toSelectDate"
    >
      <span class="label">{{ applName }}</span>
      <span class="date">{{ GET_S_E_YMD }}</span>
    </v-col>
    <v-col class="pa-0 pt-2 chips-wrap d-flex justify-end">
      <!-- chip 색상 _attendanceChip.scss 참고 -->
      <v-chip
        v-for="chip in chips"
        :class="chip.className"
        :key="chip.id"
        @click="chipClick(chip.routeName)"
        >{{ chip.chipName }}</v-chip
      >
    </v-col>
    <!-- 시간 -->
    <v-col
      cols="12"
      class="pa-0 pt-4 bt-line mt-3 d-flex justify-space-between"
      v-if="GET_DATE_TYPE === 'H'"
    >
      <span class="label">시간</span>
      <span class="date">{{ GET_REQ_S_E_HM }}</span>
    </v-col>
    <!-- 대체휴가 휴일근무일 -->
    <template v-if="isAlterVacation">
      <v-col
        cols="12"
        class="pa-0 pt-4 bt-line mt-3 d-flex justify-space-between"
        @click="toGntGubunMenu"
      >
        <span class="label">휴일근무일</span>
        <span class="date"
          >{{ GET_ALTER_VACATION.code }} <span class="divider" />
          {{ GET_ALTER_VACATION.codeNm }}</span
        >
      </v-col>
      <v-col
        class="pa-0 pt-2 chips-wrap d-flex justify-end"
        @click="toGntGubunMenu"
      >
        <span class="date">{{ GET_ALTER_VACATION.hour }}시간</span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import extraOptionsMixin from '@/mixins/extraOptionsMixin.js';

import { mapGetters } from 'vuex';

export default {
  mixins: [applCdMixin, extraOptionsMixin],
  data: () => ({
    chips: [],
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_S_E_YMD',
      'GET_REQ_S_E_HM',
      'GET_REQUEST_HOUR',
      'GET_DATE_TYPE',
      'GET_ALTER_VACATION',
    ]),

    applName() {
      if (this.isReward || this.isCancelReward) {
        return '보상휴가 신청일';
      } else {
        return this.isAlterVacation ? '대체휴가 신청일' : '근태 신청일';
      }
    },
  },
  methods: {
    // 칩 추가
    makeChips() {
      // chip 색깔 설정 필요
      this.pushChips(
        'vacation',
        this.GET_GNT_CD.codeNm,
        routerNames.GntTypeMenu,
      );

      if (this.GET_DATE_TYPE === 'D' || this.GET_DATE_TYPE === 'OD') {
        this.pushChips('day-cnt', this.GET_CLOSE_DAY + '일', '');
      }
      if (this.GET_DATE_TYPE === 'H') {
        this.pushChips('day-cnt', this.GET_REQUEST_HOUR + '시간', '');
      }
      if (this.isReward || this.isCancelReward) {
        this.pushChips('', this.GET_REQUEST_HOUR + '시간', '');
      }
    },
    chipClick(routeName) {
      // 일, 시간 이동 불가
      if (routeName === '') return false;
      // 취소신청일때는 이동 불가
      if (this.isReward || this.isCancelReward) return false;
      this.$router.push(routeName);
    },
  },

  mounted() {
    this.makeChips();
  },
};
</script>

<style></style>
